import { render, staticRenderFns } from "./DisplayCrlvModal.vue?vue&type=template&id=056e8163&scoped=true"
import script from "./DisplayCrlvModal.vue?vue&type=script&lang=js"
export * from "./DisplayCrlvModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e8163",
  null
  
)

export default component.exports